// extracted by mini-css-extract-plugin
module.exports = {"default":"UserInitials_default__IM1hi"};